import {RefObject, useEffect, useState} from "react";

interface IProps {
    defaultRatio: number;
    videoRef?: RefObject<HTMLVideoElement | null>;
    wrapperRef?: RefObject<HTMLDivElement | null>;
}

export const useReelMediaHeightSync = (props: IProps) => {
    const {wrapperRef, videoRef} = props;
    const [wrapperWidth, setWrapperWidth] = useState(0);
    const [mediaHeight, setMediaHeight] = useState(0);

    useEffect(() => {
        if (!videoRef?.current) {
            return;
        }

        const onLoadedMetaData = () => {
            const videoHeight = videoRef.current?.videoHeight;
            const videoWidth = videoRef.current?.videoWidth;

            if (videoHeight && videoWidth) {
                const ratio = videoHeight / videoWidth;
                const newVideoHeight = wrapperWidth * ratio;

                setMediaHeight(newVideoHeight);
            }
        };

        videoRef.current?.addEventListener("loadedmetadata", onLoadedMetaData);

        return () => {
            videoRef.current?.removeEventListener("loadedmetadata", onLoadedMetaData);
        };
    }, [videoRef?.current, setMediaHeight]);

    useEffect(() => {
        if (!wrapperRef?.current) {
            return;
        }

        const imgCoverResizeObserver = new ResizeObserver(() => {
            if (wrapperRef.current?.offsetWidth) {
                setWrapperWidth(wrapperRef.current.offsetWidth);
                setMediaHeight(wrapperRef.current.offsetWidth * props.defaultRatio);
            }
        });

        imgCoverResizeObserver.observe(wrapperRef.current);

        return () => {
            imgCoverResizeObserver.disconnect();
        };
    }, [wrapperRef?.current, setWrapperWidth]);

    return {
        mediaHeight
    };
};
import {RefObject, useEffect, useState} from "react";

interface IProps {
    defaultRatio: number;
    videoRef?: RefObject<HTMLVideoElement | null>;
    wrapperRef?: RefObject<HTMLDivElement | null>;
}

export const useReelMediaHeightSync = (props: IProps) => {
    const {wrapperRef, videoRef} = props;
    const [wrapperWidth, setWrapperWidth] = useState(0);
    const [mediaHeight, setMediaHeight] = useState(0);

    useEffect(() => {
        if (!videoRef?.current) {
            return;
        }

        const onLoadedMetaData = () => {
            const videoHeight = videoRef.current?.videoHeight;
            const videoWidth = videoRef.current?.videoWidth;

            if (videoHeight && videoWidth) {
                const ratio = videoHeight / videoWidth;
                const newVideoHeight = wrapperWidth * ratio;

                setMediaHeight(newVideoHeight);
            }
        };

        videoRef.current?.addEventListener("loadedmetadata", onLoadedMetaData);

        return () => {
            videoRef.current?.removeEventListener("loadedmetadata", onLoadedMetaData);
        };
    }, [videoRef?.current, setMediaHeight]);

    useEffect(() => {
        if (!wrapperRef?.current) {
            return;
        }

        const imgCoverResizeObserver = new ResizeObserver(() => {
            if (wrapperRef.current?.offsetWidth) {
                setWrapperWidth(wrapperRef.current.offsetWidth);
                setMediaHeight(wrapperRef.current.offsetWidth * props.defaultRatio);
            }
        });

        imgCoverResizeObserver.observe(wrapperRef.current);

        return () => {
            imgCoverResizeObserver.disconnect();
        };
    }, [wrapperRef?.current, setWrapperWidth]);

    return {
        mediaHeight
    };
};
